module.exports = __webpack_public_path__ + "img/logo_omir.bf545d3c.svg";